<panel width="450">
	<h1>{{ 'task-action.title' | translate }}</h1>
	<section>
		<div>
			<custom-select [label]="'task-action.type' | translate"
						   [placeholder]="'task-action.type-placeholder' | translate"
						   [selectList]="taskActionTypeList"
						   [(value)]="taskAction.type"
						   [required]="true" />
		</div>
		<div>
			<custom-select [label]="'task-action.area' | translate"
						   [placeholder]="'task-action.area-placeholder' | translate"
						   [selectList]="taskAreaList"
						   [(value)]="taskAction.taskAreaId" />
		</div>

		<div>
			<custom-select [label]="'task-action.owner' | translate"
						   [placeholder]="'task-action.owner-placeholder' | translate"
						   [selectList]="usersList"
						   [(value)]="taskAction.assignedToUserId" />
		</div>
		<div>
			<date-time-input [label]="'task-action.planned-date' | translate" [(value)]="plannedDate" (valueChange)="setPlannedDate($event)" />
		</div>

		<custom-input [(value)]="taskAction.details" [label]="'task-action.details' | translate" [inputType]="inputType.Editor" [placeholder]="'task-action.details-placeholder' | translate" />
	</section>
	<section>
		<file-upload [label]="'task-action.file-upload' | translate"
					 (busyChange)="isUploading($event)"
					 [uploadedFiles]="uploadedFiles"
					 (filesChanged)="attachmentsChanged()"
					 accept=".msg,.jpg,.pdf" />
	</section>
	@if (enableSaveButton) {
		<section>
			<button (click)="saveTaskAction()" [active]="!this.uploading">{{ 'task-action.save' | translate }}</button>
		</section>
	}
</panel>
